import { UIInteractionController } from "../../../library-js/dom-ui/interactions/UIInteractionController";
import { NGEdgeCreator } from "./NGEdgeCreator";
import { NodeGraphEvent } from "./NodeGraphEvent";
import { NodeGraphInteraction } from "./NodeGraphInteraction";
import { NodeGraph } from "../model/NodeGraph";
import { NGSelector } from "./NGSelector";
import { NGHoverEdges } from "./NGHoverEdges";
import { NGMover } from "./NGMover";

export class NodeGraphController extends UIInteractionController<NodeGraphInteraction, NodeGraphEvent>
{
  _nodeGraphEvent:NodeGraphEvent;   
  _nodeGraph:NodeGraph;

  _edgeCreator:NGEdgeCreator;
  _selector:NGSelector;
  _hoverEdges:NGHoverEdges; 
  _mover:NGMover;

  constructor( ng:NodeGraph )
  {
    super();
    this._nodeGraph = ng;
  }

  _initialize()
  {
    this._edgeCreator = new NGEdgeCreator( this._nodeGraph );
    this._selector    = new NGSelector( this._nodeGraph );
    this._hoverEdges  = new NGHoverEdges( this._nodeGraph );
    this._mover       = new NGMover( this._nodeGraph );
    
    this._interactions = 
    [
      this._mover,
      this._selector,
      this._edgeCreator,
      this._hoverEdges      
    ] 

    this._nodeGraphEvent = new NodeGraphEvent( this._nodeGraph );
    this._nodeGraphEvent.setMouseListeners( this._nodeGraph._ui.element );

    this.initialize( this._nodeGraphEvent, this._interactions );

  }
}